angular.module('impactx.productview').service('ProductViewService', ProductViewService);

ProductViewService.$inject = ['dataGen', 'TranslationService', 'ToastService', '$context', '$q', '$mdDialog'];

function ProductViewService(dataGen, TranslationService, ToastService, $context, $q, $mdDialog) {
    var validProducts = [];
    var invalidProducts = [];
    var lotFilter = [];
    var WARNING_LIMIT_PRODUCTS = 100000;

    //initially set this to true. So it is true, if a user uses CTRL+F5 while themeworld is active.
    var currentProductViewHasBeenChanged = true;

    function addProductsToProductView(products, event, totalAmount) {
        currentProductViewHasBeenChanged = true;
        if (totalAmount > WARNING_LIMIT_PRODUCTS) {
            return showProductLimitWarningDialog(totalAmount, event).then(function () {
                return sendAddProductsRequest(products)
            });
        }
        else {
            return sendAddProductsRequest(products);
        }
    }

    function addAllProductConfigsToProductView(products, event, totalAmount) {
        currentProductViewHasBeenChanged = true;
        if (totalAmount > WARNING_LIMIT_PRODUCTS) {
            return showProductLimitWarningDialog(totalAmount, event).then(function () {
                return sendAddAllProductsRequest(products)
            });
        }
        else {
            return sendAddAllProductsRequest(products);
        }
    }

    function removeProductsFromProductView(vcatId, products) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, proIds: products}, "/productview/remove/product").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function removeAllProductConfigsFromProductView(vcatId, products) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, proIds: products}, "/productview/remove/product/allconfigurations").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function deactivateActiveProductView() {
        if($context.hasActiveProductView && $context.hasActiveProductView.value) {
            var needsIndexTemp = needsIndex();
            currentProductViewHasBeenChanged = false;
            return dataGen.postAsForm({}, {needsIndex: needsIndexTemp}, "/productview/deactivate");
        }
        else {
            return $q.when();
        }
    }

    function activateProductView(id) {
        if(!$context.hasActiveProductView || !$context.hasActiveProductView.id || $context.hasActiveProductView.id != id) {
            currentProductViewHasBeenChanged = false;
        }
        dataGen.postAsForm({}, {id: id}, "/productview/activate").then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(data.trns.productViewActivated);
            });
        });
    }

    function sendAddProductsRequest(products) {
        var proIds = [];
        currentProductViewHasBeenChanged = true;
        angular.forEach(products, function (product) {
            product.basketLink.canAddToProductView = false;
            product.basketLink.canRemoveFromProductView = true;
            proIds.push(product.id);
        });

        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, proIds: proIds}, "/productview/add/product").then(function () {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function sendAddAllProductsRequest(products) {
        var proIds = [];
        currentProductViewHasBeenChanged = true;
        angular.forEach(products, function (product) {
            product.basketLink.canAddToProductView = false;
            product.basketLink.canRemoveFromProductView = true;
            product.basketLink.hasOtherConfigurationsInProductView = true;
            product.basketLink.hasOtherConfigurationsNotInProductView = false;
            proIds.push(product.id);
        });

        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, proIds: proIds}, "/productview/add/product/allconfigurations").then(function () {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function showProductLimitWarningDialog(totalAmount, event) {
        var confirm = $mdDialog.confirm()
            .title(TranslationService.get('warning'))
            .textContent(TranslationService.get('addToProductViewWarning').replace('^0', totalAmount))
            .targetEvent(event)
            .ok(TranslationService.get('accept'))
            .theme('shop')
            .cancel(TranslationService.get('abort'));

        return $mdDialog.show(confirm);
    }

    function addTendersToProductView(tenders) {
        currentProductViewHasBeenChanged = true;
        var tenderIds = [];
        angular.forEach(tenders, function(tender) {
            tender.canAddToProductView = false;
            tender.canRemoveFromProductView = true;

            tenderIds.push(tender.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, tenderIds: tenderIds}, "/productview/add/tender").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function addLotsToProductView(lots) {
        currentProductViewHasBeenChanged = true;
        var lotIds = [];
        angular.forEach(lots, function(lot) {
            lot.canAddToProductView = false;
            lot.canRemoveFromProductView = true;

            lotIds.push(lot.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, lotIds: lotIds}, "/productview/add/lot").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function addVCatsToProductView(vCats) {
        currentProductViewHasBeenChanged = true;
        var vCatIds = [];
        angular.forEach(vCats, function(vCat) {
            vCat.canAddToProductView = false;
            vCat.canRemoveFromProductView = true;

            vCatIds.push(vCat.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, vCatIds: vCatIds}, "/productview/add/vcat").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function addSuppliersToProductView(suppliers) {
        currentProductViewHasBeenChanged = true;
        var supplierIds = [];
        angular.forEach(suppliers, function(supplier) {
            supplier.canAddToProductView = false;
            supplier.canRemoveFromProductView = true;

            supplierIds.push(supplier.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveProductView.id, suppliers: supplierIds}, "/productview/add/supplier").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
        });
    }

    function removeTendersFromProductView(vcatId, tenders) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, tenderIds: tenders}, "/productview/remove/tender").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function removeLotsFromProductView(vcatId, lots) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, lotIds: lots}, "/productview/remove/lot").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function removeVCatsFromProductView(vcatId, vCats) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, vCatIds: vCats}, "/productview/remove/vcat").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function removeSuppliersFromProductView(vcatId, suppliers) {
        currentProductViewHasBeenChanged = true;
        return dataGen.postAsForm({}, {vcatId: vcatId, suppliers: suppliers}, "/productview/remove/supplier").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    function needsIndex() {
        return currentProductViewHasBeenChanged;
    }

    return {
        addProductsToProductView: addProductsToProductView,
        addTendersToProductView: addTendersToProductView,
        addLotsToProductView: addLotsToProductView,
        addVCatsToProductView: addVCatsToProductView,
        addSuppliersToProductView: addSuppliersToProductView,
        removeTendersFromProductView: removeTendersFromProductView,
        removeLotsFromProductView: removeLotsFromProductView,
        removeVCatsFromProductView: removeVCatsFromProductView,
        removeSuppliersFromProductView: removeSuppliersFromProductView,
        removeProductsFromProductView: removeProductsFromProductView,
        activateProductView: activateProductView,
        deactivateActiveProductView: deactivateActiveProductView,
        addAllProductConfigsToProductView: addAllProductConfigsToProductView,
        removeAllProductConfigsFromProductView: removeAllProductConfigsFromProductView,
        validProducts: validProducts,
        invalidProducts: invalidProducts,
        lotFilter: lotFilter
    };
}